import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Dialog, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { isMobileOnly } from 'react-device-detect';

import { NotOnMobileMessage } from '../PageLayout';

import {
  CloseIconButton, MessageContainer, NotesHeader, NotesIframe,
} from './index.styles';

interface NotesViewerDialogProps {
  href: string,
  label: string,
  shortLabel?: string,
  open: boolean,
  handleClose?: () => void,
}

const NotesViewerDialog = ({
  href,
  open,
  label,
  shortLabel = label,
  handleClose = () => {},
}: NotesViewerDialogProps) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Dialog fullScreen={!isMd} fullWidth maxWidth="lg" open={open} onClose={handleClose}>
      <NotesHeader>
        <Typography>{isMd ? label : shortLabel}</Typography>
        <CloseIconButton onClick={handleClose}>
          <CloseIcon />
        </CloseIconButton>
      </NotesHeader>
      {!isMobileOnly ? (
        <NotesIframe
          src={href}
          title="notes"
        />
      ) : (
        <MessageContainer>
          <NotOnMobileMessage />
        </MessageContainer>
      )}
    </Dialog>
  );
};

export default NotesViewerDialog;
